import styled from 'styled-components';
import { COLORS } from '../styles/variables';
import Title from '../components/EventPage/Title';
import TextBlock from '../components/EventPage/TextBlock';
import VideoBlock from '../components/EventPage/VideoBlock';
import { useQuery } from '@apollo/client';
import { GET_EVENT } from '../features/queries';
import { useParams } from 'react-router-dom';
import Loader from '../components/Shared/Loader';
import Slider from '../components/EventPage/Slider';
import { BASE_URL } from '../features/queries/config';

const Event = () => {
  const { slug } = useParams();
  const { loading, error, data } = useQuery(GET_EVENT, {
    variables: { slug: slug },
  });
  console.log(data);

  const eventData = data?.cards?.data[0].attributes;

  return (
    <EventWr>
      {loading ? (
        <Loader />
      ) : error ? (
        <div>ошибка</div>
      ) : (
        <>
          <Title>{eventData.Title}</Title>
          <Slider data={eventData} />
          <TextBlock data={eventData} />
          {eventData.video.data && (
            <VideoBlock data={BASE_URL + eventData.video.data.attributes.url} />
          )}
        </>
      )}
    </EventWr>
  );
};

const EventWr = styled.div`
  color: ${COLORS.black};
`;

export default Event;
